import { useDispatch, useSelector } from 'react-redux';
import {
  nextStep,
  prevStep,
  nextSubstep,
  prevSubstep,
  goToStep,
  goToSubstep,
  selectCurrentStep,
  selectCurrentSubstep,
  selectCurrentStepIndex,
  selectCurrentSubstepIndex,
  selectAllSteps,
} from '../redux/features/homeFlowSlice';

const useHomeFlow = () => {
  const dispatch = useDispatch();
  
  const currentStep = useSelector(selectCurrentStep);
  const currentSubstep = useSelector(selectCurrentSubstep);
  const currentStepIndex = useSelector(selectCurrentStepIndex);
  const currentSubstepIndex = useSelector(selectCurrentSubstepIndex);
  const allSteps = useSelector(selectAllSteps);

  const handleNextStep = () => {
    dispatch(nextStep());
  };

  const handlePrevStep = () => {
    dispatch(prevStep());
  };

  const handleNextSubstep = () => {
    dispatch(nextSubstep());
  };

  const handlePrevSubstep = () => {
    dispatch(prevSubstep());
  };

  const handleGoToStep = (stepIndex, substepIndex = 0) => {
    dispatch(goToStep({ stepIndex, substepIndex }));
  };

  const handleGoToSubstep = (substepIndex) => {
    dispatch(goToSubstep({ substepIndex }));
  };

  const isFirstStep = currentStepIndex === 0 && currentSubstepIndex === 0;
  const isLastStep = currentStepIndex === allSteps.length - 1 && 
    currentSubstepIndex === allSteps[currentStepIndex].substeps.length - 1;

  return {
    currentStep,
    currentSubstep,
    currentStepIndex,
    currentSubstepIndex,
    allSteps,
    handleNextStep,
    handlePrevStep,
    handleNextSubstep,
    handlePrevSubstep,
    handleGoToStep,
    handleGoToSubstep,
    isFirstStep,
    isLastStep,
  };
};

export default useHomeFlow;